import {Component} from "@angular/core";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {CustomObjectEntityModel} from "../custom-object-entity.model";
import {MembershipTypeCustomObjectSearchModel} from "../membership-type-custom-object-search.model";
import {CustomObjectSearchPageComponent} from "./custom-object-search-page.component";

@Component({
    selector: "wbo-membership-type-custom-object-search-page",
    templateUrl: "custom-object-search-page.component.html",
    providers: [provideSearchModel(MembershipTypeCustomObjectSearchModel), provideEntityModel(CustomObjectEntityModel)]
})
export class MembershipTypeCustomObjectSearchPageComponent extends CustomObjectSearchPageComponent {
    override membershipTypeContext: boolean = true;

    constructor(searchModel: MembershipTypeCustomObjectSearchModel) {
        super(searchModel);
    }
}
